import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4052c2de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "roadmap" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "roadmap__wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "roadmap__text__wrapper" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Degen Vibes Only"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" - No Bullshit "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" - No Promises "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" - CC0 "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" - Instant Reveal "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" - Great Community ")
  ])
], -1))
const _hoisted_5 = { class: "images__wrapper" }
const _hoisted_6 = { class: "wrapper__line" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "wrapper__line wrapper__images_doubler" }
const _hoisted_9 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("img", {
      class: "about__image_top",
      src: require('@/assets/roadmap.svg'),
      alt: "Roadmap Image"
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (line, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "wrapper__line-fixed",
            key: index
          }, [
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(line, (img) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "wrapper__image",
                  key: img
                }, [
                  _createElementVNode("img", {
                    src: require(`@/assets/img-bg/${img}.png`),
                    alt: "dac"
                  }, null, 8, _hoisted_7)
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(line, (img) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "wrapper__image",
                  key: img
                }, [
                  _createElementVNode("img", {
                    src: require(`@/assets/img-bg/${img}.png`),
                    alt: "dac"
                  }, null, 8, _hoisted_9)
                ]))
              }), 128))
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}